import { fetchPromotionReports } from "@api/promotionReports";
import { useEffect, useState } from "react";

export const usePromotionReports = () => {
  const [getPromotionData, setGetPromotionData] = useState([]);
  const [getPromotionDataError, setGetPromotionDataError] = useState(false);
  const [query, setQuery] = useState<any>(null);

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev: any) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    if (query) {
      fetchPromotionReports(query)
        .then((data: any) => {
          setGetPromotionData(data?.resData?.data);
        })
        .catch((err: any) => {
          setGetPromotionDataError(true);
        });
    }
  }, [query]);

  return {
    handleQuery,
    getPromotionData,
    getPromotionDataError,
  };
};
